<payee-chip-dropdown
  [placeholder]="'CASES_TABLE.FILTERS.STAGE_LABEL' | translate"
  [displayWith]="displayWith"
  [(dropdownOpen)]="dropdownOpen"
  [selected]="stage"
  (removed)="clearFilter()"
>
  <payee-dropdown
    width="short"
    [formControl]="stageControl"
    [options]="stages"
    [displayWith]="displayWith"
  ></payee-dropdown>
  <button
    payee-button
    color="primary"
    class="top-margin-10"
    width="short"
    (click)="applyFilter()"
  >
    {{ "CASES_TABLE.FILTERS.APPLY" | translate }}
  </button>
</payee-chip-dropdown>
